<template>
  <div>
    <PageTitle icon="fa fa-dollar-sign" main="BID / Cotações" />
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="2">
              <b-form-group label-size="sm" label="Moeda" label-for="filtro_moeda_id">
                <v-select
                  id="cbo_filtro_moeda_id"
                  :options="filtro_moedas"
                  label="sigla"
                  :reduce="m => m.moeda_id"
                  :clearable="false"
                  v-model="filtro_moeda_id"
                >
                  <template v-slot:option="option">{{ `${option.sigla}`}}</template>
                  <template v-slot:selected-option="option">{{ `${option.sigla}`}}</template>
                  <template #no-options="{}">Sem dados a serem exibidos</template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Data" label-size="sm" label-for="filtro_dtini">
                <date-picker
                  required
                  input-class="form-control form-control-sm"
                  :clearable="false"
                  maxlength="10"
                  format="DD/MM/YYYY"
                  value-type="format"
                  v-model="filtro_dtini"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Data" label-size="sm" label-for="filtro_dtfim">
                <date-picker
                  required
                  input-class="form-control form-control-sm"
                  :clearable="false"
                  maxlength="10"
                  format="DD/MM/YYYY"
                  value-type="format"
                  v-model="filtro_dtfim"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-button
                size="sm"
                @click="getData()"
                style="margin-top:26px !important"
                variant="primary"
              >
                <i class="fas fa-search"></i> Filtrar
              </b-button>              
            </b-col>
            <b-col lg="4">
              <b-button
                size="sm"
                @click="newRecord()"
                style="float:right;margin-top:26px !important"
                variant="success"
              >
                <i class="fas fa-plus"></i> Nova Cotação
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-table
                id="tbl"
                hover
                bordered
                resposive
                small
                striped
                head-variant="dark"
                selectable
                select-mode="single"
                selected-variant="primary"
                show-empty
                empty-text="Sem dados para exibir"
                :per-page="pagination.perPage"
                :current-page="pagination.currentPage"
                :items="quotes"
                :fields="fields"
                :busy="isBusy"
                :sort-by.sync="sortField"
                :sort-desc.sync="sortDesc"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Carregando...</strong>
                  </div>
                </template>
                <template v-slot:cell(actions)="data">
                  <b-button size="sm" variant="success" @click="editRecord(data.item)">
                    <i class="fas fa-edit"></i>
                  </b-button>
                  <b-button size="sm" variant="danger" @click="deleteRecord(data.item)">
                    <i class="fas fa-trash"></i>
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="viewRecord(data.item)">
                    <i class="fas fa-search"></i>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group label="Exibir" label-cols-lg="4" label-for="pageSize" label-size="sm">
                <b-form-select size="sm" id="pageSize" v-model="pagination.perPage">
                  <b-form-select-option :value="8">8</b-form-select-option>
                  <b-form-select-option :value="20">20</b-form-select-option>
                  <b-form-select-option :value="50">50</b-form-select-option>
                  <b-form-select-option :value="0">Tudo</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-pagination
                class="float-right"
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="tbl"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- MODAL -->
    <ModalCotacao :quote="curRecord" :action="curAction" @updated="onUpdated" />
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import ModalCotacao from "./ModalCotacao";
import { baseApiUrl, showError, formatDate, formatMoney } from "@/global";
import axios from "axios";
import { mapState } from "vuex";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import moment from 'moment'

export default {
  name: "CurrencyQuotes",
  components: { PageTitle, DatePicker, ModalCotacao },
  computed: {
    ...mapState["user"],
  },
  data: function () {
    return {
      pagination: {
        perPage: 8,
        totalRows: 0,
        currentPage: 1,
      },
      sortDesc: true,
      sortField: "dt_cotacao",
      filtro_moedas: [],
      filtro_moeda_id: 0,
      filtro_dtini: moment().add(-30, "days").format("DD/MM/YYYY"),
      filtro_dtfim: moment().add(15, "days").format("DD/MM/YYYY"),
      isBusy: false,
      curAction: "view",
      quotes: [],
      curRecord: {},
      fields: [
        {
          key: "moeda.sigla",
          label: "Moeda",
          sortable: true,
          class: "w120-field",
        },
        {
          key: "dt_cotacao",
          label: "Data",
          class: "text-center",
          sortable: true,
          formatter: function (val) {
            return formatDate(val, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY");
          },
        },
        {
          key: "vl_cotacao",
          label: "Cotação",
          class: "text-right",
          sortable: true,
          formatter: function (val) {
            return formatMoney(val, 4, "", ".", ",");
          },
        },
        { key: "actions", label: "Ações", class: "w120-field" },
      ],
    };
  },
  methods: {
    onUpdated() {
      this.curAction = "view";
      this.curRecord = {};
      this.getData();
    },
    editRecord(item) {
      this.curAction = "edit";
      this.curRecord = { ...item };
      this.curRecord.dt_cotacao = formatDate(this.curRecord.dt_cotacao, "YYYY-MM-DD", "DD/MM/YYYY")
      this.$bvModal.show("modal-cotacao");
    },
    viewRecord(item) {
      this.curAction = "view";
      this.curRecord = { ...item };
      this.$bvModal.show("modal-cotacao");
    },
    newRecord() {
      this.curAction = "new";
      this.curRecord = {
        id: 0,
        moeda_id: 2,
        dt_cotacao: formatDate(new Date(), "", "DD/MM/YYYY"),
        vl_cotacao: 1,
      };
      this.$bvModal.show("modal-cotacao");
    },
    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir a Cotação?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",

        })
        .then((yesno) => {
          if (yesno) {
            this.isBusy = true;
            axios
              .delete(`${baseApiUrl}/bid/cotacoes`, { data: {moeda_id: item.moeda_id, dt_cotacao: item.dt_cotacao}})
              .then(() => this.getData())
              .catch((err) => {
                this.isBusy = false;
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    loadCombos() {
      // moedas
      axios
        .get(`${baseApiUrl}/bid/moedas`)
        .then((resp) => {
          resp.data.splice(0, 1);
          resp.data.unshift({ moeda_id: 0, sigla: "TODAS" });
          this.filtro_moedas = resp.data;
          setTimeout(() => {
            this.filtro_moeda_id = "TODAS";
            //this.filtro_moeda_id = 0;
          }, 200);
        })
        .catch(showError);
    },
    getData() {
      this.isBusy = true;
      let _dtIni = this.filtro_dtini;
      let _dtFim = this.filtro_dtfim;
      let _url = `dtIni=${btoa(_dtIni)}&dtFim=${btoa(_dtFim)}&moedaID=${
        this.filtro_moeda_id
      }`;
      axios
        .get(`${baseApiUrl}/bid/cotacoes/listar?${_url}`)
        .then((resp) => {
          this.isBusy = false;
          this.quotes = resp.data;
          this.pagination.totalRows = this.quotes.length;
        })
        .catch((err) => {
          this.isBusy = false;
          showError(err);
        });
    },
  },
  mounted() {
    this.loadCombos();
    this.getData();
    
  },
};
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details, 
.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
        margin: 0;
        max-height: 31px;
        min-height: 31px !important;
       display: flex!important;
       align-items: center!important
}
</style>